import BaseModelAPI from '../BaseModelAPI';

export default class RemovalMethod extends BaseModelAPI {
	static entity = 'removalmethod';
	static entityName = 'removalmethod';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}